import React from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Typography } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';

interface DataParserNodeProps {
  data?: {
    label: string;
    parserType?: string;
  };
}

const DataParserNode: React.FC<DataParserNodeProps> = ({ data = { label: 'Data Parser' } }) => {
  return (
    <Box
      sx={{
        width: 140,
        height: 40,
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
        border: '1px solid #FFA726',
        px: 1,
        outline: 'none',
        '&:focus': {
          outline: 'none',
        },
        '&:hover': {
          outline: 'none',
        },
      }}
    >
      <Box
        sx={{
          width: 18,
          height: 18,
          backgroundColor: '#FF9800',
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 1,
        }}
      >
        <BuildIcon sx={{ color: '#ffffff', fontSize: 10 }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '9px', lineHeight: 1.2, color: '#1F2937' }}>
          {data.label}
        </Typography>
        {data.parserType && (
          <Typography variant="caption" sx={{ fontSize: '7px', color: '#6B7280' }}>
            {data.parserType}
          </Typography>
        )}
      </Box>
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: '#000000', width: 5, height: 5 }}
      />
      <Handle
        type="source"
        position={Position.Right}
        style={{ background: '#000000', width: 5, height: 5 }}
      />
    </Box>
  );
};

export default DataParserNode;
